import type { IAnswer, IQuestion } from "@/types/types";
import { EditableAnswer } from "../../answer/shared";
import { ModalMobile } from "@/components/modal/mobile/ModalMobile";
import { useState } from "react";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { Pill } from "@/components/pill/Pill";
import IconButton from "@/components/buttons/IconButton";
import { cn } from "@/lib/styles.utils";
import AnswerForm from "../../answer/AnswerForm";
import AnswerModalContent from "../../answer/AnswerModalContent";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";

const EditableAnswerMobile = ({
  answer,
  phaseLabel,
}: {
  answer: IAnswer;
  question: IQuestion;
  phaseLabel: string;
}) => {
  const [viewModal, setViewModal] = useState(false);
  const [edition, setEdition] = useState(false);
  const translation = useTranslate();

  const handleOnClose = () => {
    setViewModal(false);
    setEdition(false);
  };

  const handleOpenMpdal = () => {
    setViewModal(true);
  };

  const handleOnOpenAndEdit = () => {
    setEdition(true);
    setViewModal(true);
  };

  return (
    <>
      <EditableAnswer
        item={answer}
        handleOnOpenAndEdit={handleOnOpenAndEdit}
        handleOnOpen={handleOpenMpdal}
      />
      {viewModal && (
        <ModalMobile>
          <ModalMobile.Header>
            <div className="w-full flex justify-between items-center">
              <div className=" flex-1 flex items-center space-x-4">
                <h3 className="text-lg">{`${translation("action")}`}</h3>
                <Pill
                  icon={closed ? "lockClose" : "refresh"}
                  label={translation(phaseLabel)}
                  className={cn(closed ? "bg-ib-gray-lightest" : "bg-ib-blue")}
                  iconClassName=""
                />
              </div>
              <IconButton
                icon="close"
                onClick={() => setViewModal(false)}
                iconClassName={"size-6"}
                className={"bg-transparent text-ib-red-main"}
              />
            </div>
          </ModalMobile.Header>
          <ModalMobile.Content className="bg-ib-gray-lightest-2">
            {edition ? (
              <AnswerForm onClose={handleOnClose} item={answer} />
            ) : (
              <div>
                <AnswerModalContent
                  item={answer}
                  edition={edition}
                  editable
                  edit={handleOnOpenAndEdit}
                />
              </div>
            )}
          </ModalMobile.Content>
          {!edition && (
            <ModalMobile.Footer>
              <div className="w-full">
                <SecondaryButton
                  onClick={handleOnOpenAndEdit}
                  icon="pencil"
                  label={translation("edit")}
                  colour={"red"}
                />
              </div>
            </ModalMobile.Footer>
          )}
        </ModalMobile>
      )}
    </>
  );
};

export default EditableAnswerMobile;
